import React, { useState, useRef, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { nameregex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import JoditEditor from "jodit-react";
import { GrUploadOption } from "react-icons/gr";
import { getPlaceList } from "../store/slices/places";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import {
  getcarrentalPackageList,
  postcarrentalPackage,
} from "../store/slices/carrentalpackage";
import { getcarTypeRange, getcarType } from "../store/slices/carType";

const CopyCarRentalPackage = () => {
  const rangeToVehicles = useRef({});

  const editor = useRef(null);
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;
  const [isLoading, setIsLoading] = useState(true);
  const [packageErrors, setpackageErrors] = useState([]);
  const [duration, setDuration] = useState("");
  const [places, setPlaces] = useState([]);
  const [placeList, setplaceList] = useState([]);
  const [itineraryErrors, setItineraryErrors] = useState([]);
  const [range, setRange] = useState([]);
  const [packageName, setpackageName] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [imageError, setImageError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    dispatch(getcarTypeRange())
      .unwrap()
      .then((data) => {
        setRange(data?.ranges);
      })
      .catch((err) => {
        console.error("Error fetching category:", err.message);
      });
  }, [dispatch]);

  useEffect(() => {
    const fetchPackageDetails = async () => {
      try {
        const data = await dispatch(getcarrentalPackageList({ id })).unwrap();
        const packagedata = data?.packageData[0];

        const uniqueRanges = [
          ...new Set(packagedata.packages.map((p) => p.range)),
        ];

        const rangeVehicleResponses = await Promise.all(
          uniqueRanges.map(async (range) => {
            try {
              const carData = await dispatch(getcarType({ range })).unwrap();

              return { [range]: carData?.carData || [] };
            } catch (error) {
              console.error(
                `Error fetching vehicles for range ${range}:`,
                error.message,
              );
              return { [range]: [] };
            }
          }),
        );
        const rangeVehicleData = Object.assign({}, ...rangeVehicleResponses);
        const clonedPackages = packagedata.packages.map((item, index) => {
          const availableCars = rangeVehicleData[item.range] || [];

          return {
            id: `${Date.now()}-${index}`,
            range: item.range,
            price: item.price,
            entryFees: item.entryFees,
            carOptions: availableCars,
            vehicleName: availableCars.some(
              (car) => car.carName === item.vehicleName,
            )
              ? item.vehicleName
              : availableCars.length > 0
                ? availableCars[0].carName
                : "",
          };
        });

        setpackages(clonedPackages);

        const clonedIternary = (packagedata.iternary || []).map(
          (item, index) => ({
            ...item,
            id: `${Date.now()}-${index}`,
            title: item.title,
            timing: item.timing,
            description: item.description,
          }),
        );

        const initialErrors = clonedPackages.reduce((errors, item) => {
          errors[item.id] = {
            vehicleName: "",
            range: "",
            price: "",
            entryFees: "",
          };
          return errors;
        }, {});

        setpackageErrors(initialErrors);
        setIternary(clonedIternary);
        setpackages(clonedPackages);
        setpackageName(packagedata.packageName || "");
        setDuration(packagedata.duration || "");
        setDescription(packagedata.description || "");
        setImages(packagedata.images || []);
        setPlaces(packagedata.places || []);
      } catch (error) {
        console.error("Error Fetching Package Details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPackageDetails();
  }, [dispatch, id]);

  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, "").trim();
  };

  const [iternary, setIternary] = useState([
    {
      id: Date.now(),
      title: "",
      description: "",
      timing: "",
    },
  ]);

  const handleAddItinerary = (e) => {
    e.preventDefault();

    // Add a new itinerary
    const newItinerary = {
      id: Date.now(),
      title: "",
      description: "",
      timing: "",
    };
    setIternary((prevIternary) => [...prevIternary, newItinerary]);

    // Add a new error object for the new itinerary
    setItineraryErrors((prevErrors) => ({
      ...prevErrors,
      [newItinerary.id]: {
        title: "",
        description: "",
        timing: "",
      },
    }));
  };

  const handleRemoveItinerary = (id) => {
    const updatedItinerary = iternary.filter((item) => item.id !== id);
    setIternary(updatedItinerary);

    const updatedErrors = { ...itineraryErrors };
    delete updatedErrors[id];
    setItineraryErrors(updatedErrors);
  };

  const [packages, setpackages] = useState([
    {
      id: Date.now(),
      vehicleName: "",
      range: "",
      price: "",
      entryFees: "",
    },
  ]);
  const handleAddpackage = (e) => {
    e.preventDefault();

    // Add a new package
    const newpackage = {
      id: Date.now(),
      vehicleName: "",
      range: "",
      price: "",
      entryFees: "",
    };

    setpackages((prevpackages) => [...prevpackages, newpackage]);

    // Add a new error object for the new package
    setpackageErrors((prevErrors) => ({
      ...prevErrors,
      [newpackage.id]: {
        vehicleName: "",
        range: "",
        price: "",
        entryFees: "",
      },
    }));
  };

  const handleRemovepackage = (id) => {
    const updatedpackage = packages.filter((item) => item.id !== id);
    setpackages(updatedpackage);

    const updatedErrors = { ...packageErrors };
    delete updatedErrors[id];
  };

  const handleiterInputChange = (id, field, value) => {
    const updatedItinerary = [...iternary];
    const index = updatedItinerary.findIndex((i) => i.id === id);

    if (index !== -1) {
      updatedItinerary[index] = {
        ...updatedItinerary[index],
        [field]: value,
      };
      setIternary(updatedItinerary);
    }

    setItineraryErrors((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]:
          field === "description"
            ? stripHtmlTags(value).length === 0
              ? "Please enter description"
              : ""
            : value.trim() === ""
              ? "Please enter title"
              : "",
      },
    }));
  };

  const handleInputChange = async (id, field, value) => {
    const updatedPackages = [...packages];
    const updatedErrors = { ...packageErrors };

    const itemIndex = updatedPackages.findIndex((item) => item.id === id);
    if (itemIndex !== -1) {
      updatedPackages[itemIndex][field] = value;

      if (field === "range") {
        // Count occurrences of each range
        const rangeCounts = updatedPackages.reduce((acc, item) => {
          if (item.range) {
            acc[item.range] = (acc[item.range] || 0) + 1;
          }
          return acc;
        }, {});

        // Update errors for duplicate ranges
        updatedPackages.forEach((pkg) => {
          updatedErrors[pkg.id] = {
            ...updatedErrors[pkg.id],
            range:
              rangeCounts[pkg.range] > 1
                ? "Duplicate range selected"
                : pkg.range.trim() === ""
                  ? "Please select a range"
                  : "",
          };
        });

        try {
          let carOptions = [];
          if (rangeToVehicles.current[value]) {
            carOptions = rangeToVehicles.current[value];
          } else {
            const carData = await dispatch(
              getcarType({ range: value }),
            ).unwrap();

            carOptions = carData?.carData || [];
            console.log(carOptions);
            rangeToVehicles.current[value] = carOptions;
          }

          updatedPackages[itemIndex].carOptions = carOptions;

          const previousVehicle = updatedPackages[itemIndex].vehicleName;
          if (!carOptions.some((car) => car.carName === previousVehicle)) {
            updatedPackages[itemIndex].vehicleName =
              carOptions.length > 0 ? carOptions[0].carName : "";
          }
        } catch (error) {
          console.error(
            `Error fetching vehicle list for range ${value}:`,
            error.message,
          );
          updatedPackages[itemIndex].carOptions = [];
        }
      }
    }

    setpackageErrors(updatedErrors);
    setpackages(updatedPackages);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    switch (name) {
      case "packageName":
        setpackageName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter valid package name"
            : "";
        break;

      case "duration":
        setDuration(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select duration" : "";
        break;

      case "description":
        setDescription(value);
        if (errors.description && stripHtmlTags(value).length > 0) {
          setErrors((prevErrors) => ({ ...prevErrors, description: "" }));
        }
        break;

      default:
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        break;
    }

    // Update validation errors
    setErrors(validationErrors);
  };

  const handlePlaceChange = (selectedOptions) => {
    const selectedPlaces = selectedOptions.map((option) => ({
      placeId: option._id,
      name: option.name,
    }));

    setPlaces(selectedPlaces);

    const isValid = selectedPlaces.length > 0;

    setErrors((prevErrors) => ({
      ...prevErrors,
      places: isValid ? "" : "Please select at least one place",
    }));
  };

  const scrollToError = () => {
    const firstErrorField = document.querySelector(".is-invalid");
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      firstErrorField.focus();
    }
  };
  const validateForm = () => {
    let newErrors = {};

    if (!packageName.trim()) {
      newErrors.packageName = "Please enter package name";
    } else if (!nameregex.test(packageName)) {
      newErrors.packageName = "Please enter valid package name";
    }

    if (places.length === 0) {
      newErrors.places = "Please select at least one place";
    }

    if (!description.trim() || stripHtmlTags(description).length === 0) {
      newErrors.description = "Please enter valid description";
    }

    if (!duration) {
      newErrors.duration = "Please enter duration";
    }

    const itineraryErrors = iternary?.map((item) => ({
      title: item?.title.trim() === "" ? "Please enter title" : "",
      description:
        item?.description.trim() === "" ? "Please enter description" : "",
    }));
    setItineraryErrors(itineraryErrors);

    if (itineraryErrors.some((err) => err.title || err.description)) {
      newErrors.tourIternary = "Please fix errors in the itinerary section";
    }

    const rangeCounts = packages.reduce((acc, item) => {
      if (item.range) {
        acc[item.range] = (acc[item.range] || 0) + 1;
      }
      return acc;
    }, {});
    const packageErrors = {};
    packages.forEach((item) => {
      packageErrors[item.id] = {
        vehicleName:
          item.vehicleName.trim() === "" ? "Please enter vehicle name" : "",
        range:
          item.range.trim() === ""
            ? "Please select a range"
            : rangeCounts[item.range] > 1
              ? "Duplicate range selected"
              : "",
        price: item.price === "" ? "Please enter price per person" : "",
        entryFees: item.entryFees === "" ? "Please enter entry fees" : "",
      };
    });

    setpackageErrors(packageErrors);
    if (Object.values(packageErrors).some((err) => err.range)) {
      newErrors.packageDuplicate = "Duplicate range detected";
    }
    setErrors(newErrors);

    const isValid =
      Object.keys(newErrors).length === 0 &&
      itineraryErrors.every((err) => !err.title && !err.description) &&
      Object.values(packageErrors).every(
        (err) => !err.vehicleName && !err.range && !err.price && !err.entryFees,
      );

    if (!isValid) {
      scrollToError();
    }

    return isValid;
  };

  const editPackageDetails = async (e) => {
    e.preventDefault();
    setIsDisabled(true);

    setTimeout(() => setIsDisabled(false), 3000);

    if (!validateForm()) {
      setIsDisabled(false);
      return;
    }

    const item = {
      id,
      packageName,
      duration,
      iternary,
      isActive: 1,
      isApproved: 1,
      packages,
      isSpecial: 0,
      places,
      description,
      images: images,
    };

    try {
      await dispatch(postcarrentalPackage(item)).unwrap();
      alert("Package copied successfully!");
      navigate(`/admin/carrental?page=${page}`);
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  const imageUpload = async (e) => {
    setImageError("");
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      setImageError("Please select at least one file to upload");
      return;
    }
    if (images.length + files.length > 10) {
      setImageError("You can upload a maximum 10 images");
      return;
    }

    const newImage = [];
    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        setImageError("Please upload image less than 5 MB");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          "x-access-token": token,
        },
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}${API_PATHS.uploadFile}`,
          requestOptions,
        );

        if (!response.ok) {
          throw new Error(`Upload failed with status: ${response.status}`);
        }

        const data = await response.json();

        if (data?.status === 1 && data?.data?.location) {
          newImage.push({
            name: file.name,
            mediaLink: data.data.location,
            isActive: true,
          });
        } else {
          throw new Error(data.message || "Failed to upload image");
        }
      } catch (error) {
        setImageError(
          error.message || "Something went wrong while uploading the image",
        );
        return;
      }
    }

    setImages((prevImage) => [...prevImage, ...newImage]);
    e.target.value = null;
  };

  const removeImage = (index) => {
    setImages((prevImage) => {
      const updatedImage = [...prevImage];
      updatedImage.splice(index, 1);

      if (updatedImage.length === 0) {
        setImageError("Please upload at least one image");
      } else {
        setImageError("");
      }

      return updatedImage;
    });
  };

  const editorConfig = useMemo(
    () => ({
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "align",
        "font",
        "fontsize",
        "paragraph",
        "|",
        "ul",
        "ol",
        "|",
        "undo",
        "redo",
      ],
      removeButtons: ["image", "video", "file", "speech", "print", "preview"],
      readonly: false,
    }),
    [],
  );

  React.useEffect(() => {
    dispatch(getPlaceList())
      .unwrap()
      .then((data) => {
        const formattedPlaces = data?.placesData.map((place) => ({
          _id: place._id,
          name: place.name || "Unnamed Place",
        }));
        setplaceList(formattedPlaces || []);
      })
      .catch((err) => {
        console.error("Error fetching places:", err.message);
      });
  }, [dispatch]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Edit Package</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/carrental"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Packages
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Edit Package</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={editPackageDetails}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Package Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="packageName"
                  value={packageName}
                  maxLength={150}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.packageName ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Package Name"
                />
                {errors.packageName && (
                  <div className="text-danger mt-2">{errors.packageName}</div>
                )}
              </div>

              <div className="col-md-5">
                <label className="form-label">
                  Duration <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="duration"
                  value={duration}
                  onChange={handleChange}
                  placeholder="Enter duration"
                  className={`form-control ${
                    errors.duration ? "is-invalid" : ""
                  }`}
                />

                {errors.duration && (
                  <div className="text-danger mt-2">{errors.duration}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Places<span className="text-danger">*</span>
                </label>
                <Typeahead
                  id="basic-typeahead-multiple"
                  labelKey="name"
                  multiple
                  onChange={handlePlaceChange}
                  options={placeList?.map((place) => ({
                    _id: place._id,
                    name: place.name || "Unnamed Place",
                  }))}
                  placeholder="Select Places"
                  selected={
                    places.length > 0
                      ? places.map((place) => ({
                          _id: place.placeId, // Ensure you're using the correct placeId
                          name: place.name || "Unnamed Place", // Make sure the name is also mapped correctly
                        }))
                      : [] // If there are no places selected, return an empty array
                  }
                />

                {errors.places && (
                  <div className="text-danger mt-2">{errors.places}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Images <span className="text-danger">*</span>
                </label>
                <br />
                <label for="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  id="fileInput"
                  name="image"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                  multiple
                />
                {imageError && (
                  <div className="text-danger mt-2">{imageError}</div>
                )}
                <div className="row mt-3">
                  {images?.map((img, index) => (
                    <div
                      className="col-md-2 mb-2 position-relative"
                      key={index}
                    >
                      <img
                        src={img.mediaLink}
                        style={{ height: "120px", objectFit: "cover" }}
                        alt=""
                        className="img-thumbnail"
                      />
                      <button
                        className="image-remove-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          removeImage(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={description}
                  onChange={(newContent) => {
                    setDescription(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      description:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid description"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.description && (
                  <div className="text-danger mt-2">{errors.description}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Itinerary <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  {iternary?.map((item) => (
                    <div
                      key={item.id}
                      className="container border p-3 mb-3 rounded"
                    >
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          className="btn btn-primary-600 me-2"
                          onClick={handleAddItinerary}
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                        >
                          <CiCirclePlus style={{ fontSize: "25px" }} />
                        </button>
                        <button
                          className="btn btn-outline-primary-600"
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                          onClick={() => handleRemoveItinerary(item.id)}
                          disabled={iternary.length === 1}
                        >
                          <CiCircleMinus style={{ fontSize: "25px" }} />
                        </button>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <label className="form-label">
                            Title <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter title"
                            value={item.title}
                            onChange={(e) =>
                              handleiterInputChange(
                                item.id,
                                "title",
                                e.target.value,
                              )
                            }
                            className="form-control"
                          />
                          {itineraryErrors[item.id]?.title && (
                            <span className="error-message">
                              {itineraryErrors[item.id]?.title}
                            </span>
                          )}
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Timing</label>
                          <input
                            type="text"
                            placeholder="Enter timing"
                            value={item?.timing}
                            onChange={(e) =>
                              handleiterInputChange(
                                item.id,
                                "timing",
                                e.target.value,
                              )
                            }
                            className="form-control"
                          />
                          {itineraryErrors[item.id]?.timing && (
                            <span className="error-message">
                              {itineraryErrors[item.id]?.timing}
                            </span>
                          )}
                        </div>

                        <div className="col-md-12 mt-3">
                          <label className="form-label">
                            Details<span className="text-danger">*</span>
                          </label>
                          <JoditEditor
                            value={item.description || ""}
                            config={editorConfig}
                            onChange={(newContent) =>
                              handleiterInputChange(
                                item.id,
                                "description",
                                newContent,
                              )
                            }
                          />

                          {itineraryErrors[item.id]?.description && (
                            <span className="error-message">
                              {itineraryErrors[item.id]?.description}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Price <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  {packages?.map((item) => (
                    <div
                      key={item.id}
                      className="container border p-3 mb-3 rounded"
                    >
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          className="btn btn-primary-600 me-2"
                          onClick={handleAddpackage}
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                        >
                          <CiCirclePlus style={{ fontSize: "25px" }} />
                        </button>
                        <button
                          className="btn btn-outline-primary-600"
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                          onClick={() => handleRemovepackage(item.id)}
                          disabled={packages.length === 1}
                        >
                          <CiCircleMinus style={{ fontSize: "25px" }} />
                        </button>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-4">
                          <label className="form-label">
                            Members
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            name="range"
                            value={item.range}
                            onChange={(e) =>
                              handleInputChange(
                                item.id,
                                "range",
                                e.target.value,
                              )
                            }
                            className={`form-control ${
                              packageErrors[item.id]?.range ? "is-invalid" : ""
                            }`}
                          >
                            <option value="">Select</option>
                            {range?.map((rangeOption) => (
                              <option key={rangeOption} value={rangeOption}>
                                {rangeOption}
                              </option>
                            ))}
                          </select>
                          {packageErrors[item.id]?.range && (
                            <div className="text-danger mt-2">
                              {packageErrors[item.id]?.range}
                            </div>
                          )}
                        </div>

                        <div className="col-md-4">
                          <label className="form-label">
                            Vehicle Name <span className="text-danger">*</span>
                          </label>
                          <select
                            name="vehicleName"
                            value={item.vehicleName}
                            onChange={(e) =>
                              handleInputChange(
                                item.id,
                                "vehicleName",
                                e.target.value,
                              )
                            }
                            className={`form-control ${
                              packageErrors[item.id]?.vehicleName
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option value="">Select Vehicle</option>
                            {item.carOptions?.map((car) => (
                              <option key={car._id} value={car.carName}>
                                {car.carName}
                              </option>
                            ))}
                          </select>

                          {packageErrors[item.id]?.vehicleName && (
                            <span className="error-message">
                              {packageErrors[item.id]?.vehicleName}
                            </span>
                          )}
                        </div>

                        <div className="col-md-4">
                          <label className="form-label">
                            Price
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="price"
                            value={item.price}
                            onChange={(e) =>
                              handleInputChange(
                                item.id,
                                "price",
                                e.target.value,
                              )
                            }
                            className={`form-control ${
                              packageErrors[item.id]?.price ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Price per person"
                          />
                          {packageErrors[item.id]?.price && (
                            <div className="text-danger mt-2">
                              {packageErrors[item.id]?.price}
                            </div>
                          )}
                        </div>
                        <div className="col-md-4 mt-3">
                          <label className="form-label">
                            Entry Fees
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="entryFees"
                            value={item.entryFees}
                            onChange={(e) =>
                              handleInputChange(
                                item.id,
                                "entryFees",
                                e.target.value,
                              )
                            }
                            className={`form-control ${
                              packageErrors[item.id]?.entryFees
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Enter Price per child"
                          />
                          {packageErrors[item.id]?.entryFees && (
                            <div className="text-danger mt-2">
                              {packageErrors[item.id]?.entryFees}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CopyCarRentalPackage;
